import { Button } from "@portal/BaseComponents/Button/AntButton";
import { Drawer } from "@portal/BaseComponents/Drawer/AntDrawer";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { Icon } from "@portal/lib/icons/icons";
import { ValidFileType } from "@portal/types/file";
import { Fragment, useState } from "react";

interface DocPreviewProps {
  docType: ValidFileType;
  docUrl?: string;
  open: boolean;
  onClose: () => void;
  onLoad?: () => void;
}

const CloseIcon = <Icon icon={["far", "times"]} color="var(--gray-7)" />;
function DocPreview(props: DocPreviewProps) {
  const { docType, docUrl, open, onClose, onLoad } = props;
  const [contentChanged, setContentChanged] = useState(false);

  const Iframe = (
    <iframe
      onLoad={() => {
        setContentChanged(true);
        onLoad?.();
      }}
      allowFullScreen={true}
      title={`${docType} viewer`}
      src={`${docUrl}`}
      width="100%"
      height="100%"
      style={{
        display: contentChanged ? "inline" : "none",
        background: "transparent",
      }}
    />
  );

  const CloseButton = <Button icon={CloseIcon} onClick={onClose} />;

  const Title = (
    <Flex justify="space-between" align="center" style={{ width: "100%" }}>
      <TypographyText strong fs="20">{`${docType} viewer`}</TypographyText>
      {CloseButton}
    </Flex>
  );
  return (
    <Fragment>
      {contentChanged && (
        <Drawer
          open={open}
          footer={false}
          width="800"
          closable={false}
          title={Title}
          maskClosable
          onClose={onClose}
        >
          {Iframe}
        </Drawer>
      )}
      {open && !contentChanged && Iframe}
    </Fragment>
  );
}

export { DocPreview };
